import * as actions from '@src/store/actions';
import * as selectors from '@src/store/selectors';
import { getApiData } from '@src/utils/deprecatedCommon';
import { isProd } from '@src/utils/env';

export { waitForStoreSettled, isSideEffectSettled, SSR_HARD_DEADLINE_MS } from '@src/router/waitForStoreSettled';

export const defaultActionCalls = {
	actionCall: ({ req, store, query }) => {
		const { preview } = query;
		const faultAll = query.fault_all;
		const apiData = getApiData(req);
		const { ssrHeaders, domain } = apiData;

		const ssrHeadersWithFault = (!isProd && faultAll) ?
			{ ...ssrHeaders, 'X-Internal-Fault-Inject': faultAll } :
			ssrHeaders;

		store.dispatch(actions.getThemesCall({ temporary: preview, ssrHeaders: ssrHeadersWithFault, store }));
		store.dispatch(actions.setDomain({ domain }));
	},
	actionDone: ({ store }) => {
		const state = store.getState();
		const { themeState } = selectors.getThemeSelector(state);

		return themeState !== 'IDLE' && themeState !== 'LOADING';
	},
	updateHydrateState: (draft, nextState) => {
		draft.theme = nextState.theme;
		draft.ssr = nextState.ssr;
		draft.category = nextState.category;
	},
};

export async function execDefaultServerSideProps(ctx) {
	const { store, query } = ctx;

	const success = await new Promise(resolve => {
		const unsubscribe = store.subscribe(() => {
			const defaultActionDone = defaultActionCalls.actionDone(ctx);

			if (defaultActionDone) {
				resolve(unsubscribe);
			}
		});

		defaultActionCalls.actionCall(ctx);
	});

	success();

	if (!isProd && query?.fault_all) {
		const state = store.getState();
		const { themeState } = selectors.getThemeSelector(state);
		if (themeState === 'FAIL') {
			throw new Error(`SSR fault injected via ?fault_all=${query.fault_all}: theme load failed`);
		}
	}
}
